<template>
  <w-form-table>
    <thead>
      <tr>
        <th>Rola</th>

        <th>
          <span class="sr-only">Akcje</span>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(item, index) in model.$items" :key="'list_' + index">
        <w-table-cell :model="item.$item.name">
          <w-select :values="roles" :model="item.$item" />
        </w-table-cell>

        <w-row-buttons class="middle flex-nowrap" :model="item.$item" :move-up="false" :move-down="false" />
      </tr>

      <tr>
        <td colspan="4">
          <w-add-row :model="model">Dodaj rolę</w-add-row>
        </td>
      </tr>
    </tbody>
  </w-form-table>
</template>

<script>
import { mapState } from 'vuex';
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Edycja ról formularza przycisku
export default {
  components,
  props: {
    model: { type: Object, require: true }
  },
  computed: mapState({
    roles: state => state.role.list.map(role => ({ value: role.id, text: role.name }))
  })
};
</script>
